export default __webpack_public_path__ + "static/media/about-banner.02bde3dd.jpg";